/*
 * EXTERMAL IMPORTS
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Loader, Grid, Message } from "semantic-ui-react";
import classNames from "classnames";
/*
 * CSS IMPORTS
 */
import "../App.css";
import "./AFrameControlApp.css";
/*
 * INTERNAL LIBRARY AND UTILITY IMPORTS
 */
import * as Constants from "./../utils/Constants";
import AFrameConstants from "../lib/aframeboxlookup/Constants";
import { getOperatorMessage } from "../lib/aframeboxlookup/UtilMethods";
import * as UtilMethods from "../utils/UtilMethods";
import SharedFunctions from "../utils/SharedFunctions";

/*
 * INTERNAL COMPONENT IMPORTS
 */
import Login from "./Login/Login";
import ErrorAlert from "./ErrorAlert/ErrorAlert";
import BoxItemList from "./BoxItemList/BoxItemList";
import InfoFooter from "./InfoFooter/InfoFooter";
import WarningList from "./AFrameControlStation/WarningList/WarningList";
import InfoBar from "./InfoBar/InfoBar";
import App from "../App";
/*
 * ACTION IMPORTS
 */
import {
  clearReviewBoxData,
  fetchAFrameReviewBox,
  setReviewBoxData,
  setMissingBoxItem,
  verifyRxBagsRequired,
  setVerifiedRxBagsEAN,
  setConfirmWrongRxBagScan,
} from "../lib/store/reducers/aFrameReviewBoxReducer";
import { setUser, setWorkstation } from "../lib/store/reducers/loginInfoReducer";
import {
  setAFrameAction,
  setAFrameControlStationType,
  setAFrameControlStationVisibleType,
  setAframeReviewWarning,
  toggleScanDisabled,
} from "../lib/store/reducers/aframeModeReducer";
import {
  setAppMode,
  setError,
  clearError,
  setLoadingStatus,
  setLoginStatus,
} from "../lib/store/reducers/applicationStateReducer";
import { ApplicationMode } from "../lib/store/types/ApplicationStateTypes";
import { PayloadWrapper } from "../lib/store/types/PayloadWrapper";
import { OperatorInfoModel } from "../lib/interfaces/Login/IOperatorInfoModel";
import { WorkstationInfoModel } from "../lib/interfaces/Login/IWorkstationInfoModel";
import SideBarMenu from "./SideBarMenu/SideBarMenu";
import WarningModal from "./WarningModal/WarningModal";
import SortBoxEndpoints from "../lib/sortbox/SortBoxEndpoints";
import MissingSkuModalSelectMissing from "./MissingSkuModal/MissingSkuModalSelectMissing";
import RxBagVerificationModal from "./BoxReview/components/RxBagVerificationModal/RxBagVerificationModal";
import OperatorConfirmModal from "./OperatorConfirmModal/OperatorConfirmModal";
import {
  setIsBetaWorkstation,
  setShouldRedirect,
} from "../lib/store/reducers/applicationStateReducer";
import { setCompanyID } from "../lib/store/reducers/cartReducer";
import WorkstationEndpoints from "../lib/workstation/WorkstationEndpoints";
import { checkVersion } from "../utils/versionCheck/versionCheck";

const { ActionStates, LookupValueOrigin, AFrameControlStationType } = AFrameConstants;

class AFrameControlApp extends Component {
  _gsCharInputFix;
  _handleArticleScanSkuPutaway;
  constructor() {
    super();
    this.inputRef = React.createRef();
    this._addError = this._addError.bind(this);
    this._skuIsMissing = this._skuIsMissing.bind(this);
    this._performSkuPutaway = this._performSkuPutaway.bind(this);
    this._gsCharInputFix = UtilMethods.GSCharInputFix.bind(this);
    this._updateBoxItems = this._updateBoxItems.bind(this);
    this._handleArticleScanSkuPutaway = UtilMethods.HandleArticleScanSkuPutaway.bind(this);
    this._setInputFocus = this._setInputFocus.bind(this);
  }

  _performSkuPutaway = (boxItem, input) => {
    let reviewBox = { ...this.props.reviewBox, missingBoxItem: null };
    //perform stock transfer
    SortBoxEndpoints.putawayStock(
      boxItem.boxID,
      boxItem.shelfNumber,
      boxItem.isRxItem,
      boxItem.missingQuantity,
      boxItem.skuID,
      input,
      this.props.reviewBox.supplierDeliveryId
    )
      .then((response) => {
        boxItem.verifiedQuantity = boxItem.reservedQuantity - boxItem.missingQuantity;
        reviewBox.supplierDeliveryId = response.supplierDeliveryId;
        let remainingItems = this.props.reviewBox.boxItems.filter(
          (x) =>
            x.verifiedQuantity < x.reservedQuantity - x.missingQuantity &&
            x.reservedQuantity - x.missingQuantity > 0
        );
        var aframeAction = this.props.aframe.aFrameAction;
        this.props.setAframeReviewWarning("Placera produkten i lagerback: " + response.shelfNumber);
        if (remainingItems.length == 0) {
          reviewBox.boxItems = [];
          reviewBox.allSortBoxItems = [];
          reviewBox.hasWarnings = true;
          reviewBox.warnings = ["Lägg tillbaka tomma lådan på uppsamlingsplats."];
          this.props.setReviewBoxData(reviewBox, aframeAction, this._setInputFocus);
        } else this.props.setReviewBoxData(reviewBox, aframeAction, this._setInputFocus);
        this.props.toggleLoading(false);
      })
      .catch((e) => {
        this._addError("Kunde inte genomföra lagerflytt:" + e);
      });
  };

  _setInputFocus() {
    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }
  _updateBoxItems(boxItems) {
    var aframeAction = this.props.aframe.aFrameAction;
    let reviewBox = { ...this.props.reviewBox, missingBoxItem: null, boxItems };
    this.props.setReviewBoxData(reviewBox, aframeAction, this._setInputFocus);
    this.props.toggleLoading(false);
  }

  _verifyRxBag(input, boxItems, verifiedRxBagsEan, orderNumber) {
    var currentBoxItem = boxItems.find((i) => i.isRx && i.eans[0] == input);
    if (currentBoxItem) {
      verifiedRxBagsEan.push(currentBoxItem.eans[0]);
      this.props.setVerifiedRxBagsEAN(verifiedRxBagsEan);
      SharedFunctions.LogScannedRXBag(currentBoxItem.eans[0]);
      if (
        boxItems.filter((x) => x.skuID >= Constants.RX_BAG_SKU).length == verifiedRxBagsEan.length
      )
        this.props.verifyRxBagsRequired(false);
    } else {
      this.props.setConfirmWrongRxBagScan(true);
      SharedFunctions.LogIncorrectScannedRXBag(input, orderNumber);
    }
  }

  _skuIsMissing = (skuID, shelfNumber) => {
    let missingItem = this.props.reviewBox.boxItems.find(
      (bi) => bi.skuID === skuID && bi.shelfNumber === shelfNumber
    );
    this.props.setMissingBoxItem(missingItem);
  };

  render() {
    let classes = classNames({
      aFrameControlApp: this.props.aframe.aFrameAction === ActionStates.LOAD_BOX,
      aFrameControlAppInitialMode: this.props.reviewBox.boxID === -1,
    });

    if (!this.props.loginInfo.operatorID || this.props.loginInfo.operatorID === -1) {
      return (
        <React.Fragment>
          <Login
            loginCallback={this._signIn}
            workstationID={UtilMethods.getParamValue("ws")}
            loginView={Constants.VIEW.AFRAME}
          />
          <ErrorAlert error={""} style={{ top: "100px" }} />
        </React.Fragment>
      );
    }

    if (this.props.aframe.aFrameAction === ActionStates.COMPLETE_BOX) {
      return <App></App>;
    }

    const { loading } = this.props.appState;
    const {
      channelItems,
      dynamicChannelItems,
      orderNumber,
      warnings,
      hasWarnings,
      sortID,
      shippingMethod,
      latestShipping,
      boxID,
      orderChecked,
      allSortBoxItems,
      rxFloorVisited,
      verifiedRxBagsEan,
      verifyRxBagsRequired,
      confirmWrongRXScan,
    } = this.props.reviewBox;

    let { boxItems } = this.props.reviewBox;

    let putawayStockMode = this.props.aframe.aFrameAction === ActionStates.PUTAWAY_STOCK;

    const aFrameControlStationVisibleType = this.props.aframe.aFrameControlStationVisibleType;

    let classes2 = classNames({
      aFrameControlStationTypeInfo: true,
      large: true,
      typeOne: aFrameControlStationVisibleType === 1 ? true : false,
      typeTwo: aFrameControlStationVisibleType === 2 ? true : false,
      typeThree: aFrameControlStationVisibleType === 3 ? true : false,
    });
    let aFrameName = "";
    switch (aFrameControlStationVisibleType) {
      case 1:
        aFrameName = "(Nya)";
        break;
      case 2:
        aFrameName = "(Gamla)";
        break;
      case 3:
        aFrameName = "(Väst)";
        break;
    }

    const { operatorName } = this.props.loginInfo;
    return (
      <div className={classes}>
        <Dimmer active={loading} inverted>
          <Loader size="big" />
        </Dimmer>
        {this.props.aframe.aFrameAction === ActionStates.LOAD_BOX ? (
          <SideBarMenu logOut={() => this._signOut()}></SideBarMenu>
        ) : null}
        {boxID === -1 ? (
          <Message size="massive" info className={classes2}>
            Kontrollstation - AFrame {aFrameControlStationVisibleType} {aFrameName}
          </Message>
        ) : null}
        {this.props.aframe.warningMessage ? (
          <WarningModal
            open={true}
            cssClass={"warning-modal-instruction"}
            autoClose={false}
            header="Avbruten"
            message={this.props.aframe.warningMessage}
            onClose={() => {
              this.props.setAframeReviewWarning(null);
              this._setInputFocus();
            }}
          ></WarningModal>
        ) : null}
        <RxBagVerificationModal
          open={verifyRxBagsRequired}
          verify={(input) => {
            this._verifyRxBag(input, boxItems, verifiedRxBagsEan, orderNumber);
          }}
          toCheckCount={boxItems.filter((x) => x.skuID >= Constants.RX_BAG_SKU).length}
          checkedCount={verifiedRxBagsEan.length}
          close={() => {
            this.props.setAframeReviewWarning(
              "Du måste scanna rx-påsarna och kontrollera att dessa tillhör lådan."
            );
          }}
          confirmWrongRXScanOpen={confirmWrongRXScan}
        />
        <OperatorConfirmModal
          open={confirmWrongRXScan}
          SortBoxID={boxID}
          orderNumber={orderNumber}
          isScanIdValidationRxRequired={true}
          onClose={() => {
            this.props.setConfirmWrongRxBagScan(false);
          }}
          reviewMode={true}
        />
        <Grid columns={2} className="GridContainer">
          <Grid.Column className={putawayStockMode ? "putawayStock" : "articleColumn"} width={12}>
            {putawayStockMode ? (
              <div style={{ textAlign: "center" }}>
                <h1>SCANNA TILL LAGERBACK</h1>
              </div>
            ) : null}
            <BoxItemList
              aframe={true}
              skuChannels={channelItems}
              dynamicSkuChannels={dynamicChannelItems}
              additionalClasses="aframeBoxList"
              skuInputCallback={
                putawayStockMode
                  ? (input, scanInputType, origin = "") => {
                      if (this.props.aframe.aFrameAction === ActionStates.PUTAWAY_STOCK) {
                        this.props.toggleLoading(true);
                        this._handleArticleScanSkuPutaway(
                          input,
                          scanInputType,
                          boxItems,
                          this._updateBoxItems,
                          this._performSkuPutaway,
                          this._addError,
                          true
                        );
                      }
                    }
                  : {}
              }
              boxItems={boxItems}
              isLoading={loading}
              isWaitingForBox={false}
              allSortBoxItems={allSortBoxItems}
              rxFloorVisited={rxFloorVisited}
              skuIsMissingCallback={this._skuIsMissing}
              alwaysShowMissing={!putawayStockMode && this.props.reviewBox.invoiceNumber === -1}
            ></BoxItemList>
          </Grid.Column>
          <Grid.Column className="flexColumn" width={4}>
            <InfoBar
              isAuto={true}
              operatorInstruction={getOperatorMessage(this.props.aframe.aFrameAction)}
              nextAction={this.props.aframe.aFrameAction}
              currentOrderNumber={orderNumber}
              fromAFrameControl={true}
              sortID={sortID}
              shippingMethod={shippingMethod}
              latestShipping={latestShipping}
              aFrameControlStation={aFrameControlStationVisibleType}
              orderStatus={this.props.reviewBox.orderStatus}
            ></InfoBar>
            <WarningList
              orderCompletition={putawayStockMode}
              infoBarHeight={this.props.layout.height}
              hasWarnings={hasWarnings}
              warnings={warnings}
              boxID={boxID}
              orderChecked={orderChecked}
            ></WarningList>
          </Grid.Column>
        </Grid>
        <ErrorAlert error={this.props.appState.errorMessage} />
        <InfoFooter
          operatorName={operatorName}
          isApoteaPackaging={true}
          sortID={sortID}
          orderNumber={this.props.reviewBox.orderNumber}
        />
        {this.props.reviewBox.missingBoxItem && (
          <MissingSkuModalSelectMissing
            reservedQuantityIsMaxMissing={true}
            onCloseClearState={() => {
              this.props.setMissingBoxItem(null);
              this._setInputFocus();
            }}
            boxItem={this.props.reviewBox.missingBoxItem}
            missingSkuSetVerifiedQuantity={(missingAmount, missingBoxItem) => {
              if (putawayStockMode) {
                var reviewBox = this.props.reviewBox;
                if (missingBoxItem.reservedQuantity - missingAmount !== 0) {
                  missingBoxItem.missingQuantity = missingAmount;
                  if (
                    missingBoxItem.reservedQuantity - missingAmount ===
                    missingBoxItem.verifiedQuantity
                  ) {
                    this._performSkuPutaway(missingBoxItem, "");
                  }
                } else {
                  reviewBox = {
                    ...this.props.reviewBox,
                    boxItems: this.props.reviewBox.boxItems.filter(
                      (i) => !UtilMethods.isBoxItemMatch(i, missingBoxItem)
                    ),
                  };
                  reviewBox.allSortBoxItems = this.props.reviewBox.allSortBoxItems.filter(
                    (i) => !UtilMethods.isBoxItemMatch(i, missingBoxItem)
                  );
                }

                this.props.setReviewBoxData(
                  reviewBox,
                  this.props.aframe.aFrameAction,
                  this._setInputFocus
                );
                this.props.setMissingBoxItem(null);
              } else {
                missingBoxItem.verifiedQuantity = missingBoxItem.reservedQuantity - missingAmount;
                this.props.setAFrameAction(new PayloadWrapper(ActionStates.COMPLETE_BOX));
              }
            }}
          />
        )}
        <input
          className="ScanInputField"
          autoComplete="off"
          id="ScanInputField"
          autoFocus
          onKeyPress={(e) => this._onInputKeyPress(e)}
          ref={this.inputRef}
          disabled={this.props.aframe.scanDisabled || this.props.appState.warningMessage}
        />
      </div>
    );
  }

  _onInputKeyPress = (e) => {
    if (e.key !== "Enter") {
      return;
    }

    const target = e.target;

    this._submitInput(target);
  };

  _submitInput = (targetRef) => {
    let { boxItems } = this.props.reviewBox;
    let input = targetRef.value.trim().toUpperCase();

    if (this.props.aframe.aFrameAction === ActionStates.PUTAWAY_STOCK) {
      let inputType = UtilMethods.ParseInputType(input);
      this._handleArticleScanSkuPutaway(
        input,
        inputType,
        boxItems,
        this._updateBoxItems,
        this._performSkuPutaway,
        this._addError,
        true
      );
    } else {
      //CHECK WHAT TYPE OF INPUT
      this._loadBox(LookupValueOrigin.ScannedBarcode, input);
    }

    targetRef.value = "";
  };

  _addError(message) {
    this.props.setError({
      message,
      visible: true,
      errorType: -1,
    });
    this._setInputFocus();
    this.props.toggleLoading(false);
  }

  _toggleLoading = (loading) => {
    this.props.toggleLoading(loading);
    this.props.toggleScan(true);
  };

  _loadBox = (type, input) => {
    this._performShouldRedirect();
    this.props.clearError();
    this.props.fecthAFrameReviewBox(
      type,
      input,
      (message) => this._addError(message),
      () => this._setInputFocus()
    );
  };

  _performShouldRedirect = () => {
    const { loggedIn, shouldRedirect } = this.props.appState;
    if (loggedIn && shouldRedirect) {
      this.props.setShouldRedirect(true);
      this.props.setLoginStatus(false);
    }
  };

  _signIn = async (operator) => {
    const workstationID = UtilMethods.getParamValue("ws");
    const aFrameControlStationType = UtilMethods.getParamValue("aframe");

    if (UtilMethods.Validation.validatePositiveInteger(aFrameControlStationType)) {
      const type = parseInt(aFrameControlStationType);

      if (!Object.values(AFrameControlStationType).includes(type)) {
        this._addError("Felaktig kontrollstationstyp");
      } else {
        let operatorID = -1;
        let operatorName = "Okänd";
        if (typeof operator === "object") {
          operatorID = operator.operatorId;
          operatorName = operator.operatorName;
        } else {
          operatorID = operator;
        }

        //INVERTS THE CONTROLSTATIONTYPE FOR TYPE 1 AND 2 FOR BACKEND PURPOSES.
        if (type === 1) {
          this.props.setAFrameControlStationType(2);
        } else if (type === 2) {
          this.props.setAFrameControlStationType(1);
        } else {
          this.props.setAFrameControlStationType(type);
        }
        this.props.setAFrameControlStationVisibleType(type);
        this.props.setWorkstation(workstationID, 30, 12);
        this.props.setAppMode(ApplicationMode.AFrameReviewMode);
        this.props.setUser(operatorID, operatorName);
        this.props.setLoginStatus(true);
        await this._setIsBetaWorkStation(workstationID);
      }
    } else {
      this._addError("Felaktig kontrollstationstyp");
    }
  };

  _signOut = () => {
    this.props.setLoginStatus(false);
  };

  async componentDidMount() {
    this._gsCharInputFix();
    this._versionCheckPoll();
  }

  async componentDidUpdate() {
    this._setInputFocus();
    this._gsCharInputFix();
  }

  componentWillUnmount() {
    if (this._versionCheckInterval != undefined) {
      clearInterval(this._versionCheckInterval);
    }
  }

  async _setIsBetaWorkStation(workstationId) {
    WorkstationEndpoints.isBetaWorkstation(workstationId)
      .then((res) => {
        this.props.setIsBetaWorkstation(res);
      })
      .catch((error) => {
        this._addError(error);
      });
  }

  _versionCheckPoll = () => {
    this._versionCheckInterval = setInterval(
      () =>
        checkVersion((shoudRedirect) => {
          if (shoudRedirect !== this.props.appState.shouldRedirect) {
            this.props.setShouldRedirect(shoudRedirect);
          }
        }),
      20000
    );
  };
}

const mapStateToProps = (state) => {
  return {
    aframe: state.aframeModeReducer,
    reviewBox: state.aFrameReviewBoxReducer,
    loginInfo: state.loginInfoReducer,
    layout: state.layoutHelperReducer,
    appState: state.applicationStateReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAppMode: (mode) => dispatch(setAppMode(new PayloadWrapper(mode))),
    setAFrameControlStationType: (type) =>
      dispatch(setAFrameControlStationType(new PayloadWrapper(type))),
    setAFrameControlStationVisibleType: (type) =>
      dispatch(setAFrameControlStationVisibleType(new PayloadWrapper(type))),
    toggleLoading: (loading) => dispatch(setLoadingStatus(loading)),
    clearReviewBoxModel: () => dispatch(clearReviewBoxData()),
    setUser: (operatorID, operatorName) =>
      dispatch(setUser(new OperatorInfoModel(operatorID, operatorName))),
    setError: (payload) => dispatch(setError(payload)),
    clearError: () => dispatch(clearError()),
    setWorkstation: (workstationID, WorkstationType, branchID) =>
      dispatch(setWorkstation(new WorkstationInfoModel(workstationID, WorkstationType, branchID))),
    setAFrameAction: (action) => dispatch(setAFrameAction(action)),
    fecthAFrameReviewBox: (type, input, errorCallback, focusCallback) =>
      dispatch(fetchAFrameReviewBox({ type, input, errorCallback, focusCallback })),
    toggleScan: (value) => dispatch(toggleScanDisabled(new PayloadWrapper(value))),
    setLoginStatus: (status) => dispatch(setLoginStatus(new PayloadWrapper(status))),
    setAframeReviewWarning: (value) => dispatch(setAframeReviewWarning(new PayloadWrapper(value))),
    setMissingBoxItem: (value) => dispatch(setMissingBoxItem(new PayloadWrapper(value))),
    setReviewBoxData: (reviewBox, aFrameAction, focusCallback) =>
      dispatch(
        setReviewBoxData({
          reviewBox: reviewBox,
          aFrameAction,
          focusCallback,
        })
      ),
    verifyRxBagsRequired: (value) => dispatch(verifyRxBagsRequired(new PayloadWrapper(value))),
    setVerifiedRxBagsEAN: (value) => dispatch(setVerifiedRxBagsEAN(new PayloadWrapper(value))),
    setConfirmWrongRxBagScan: (value) =>
      dispatch(setConfirmWrongRxBagScan(new PayloadWrapper(value))),
    setIsBetaWorkstation: (beta) => dispatch(setIsBetaWorkstation(new PayloadWrapper(beta))),
    setCompanyID: (companyId) => dispatch(setCompanyID(new PayloadWrapper(companyId))),
    setShouldRedirect: (shouldRedirect) =>
      dispatch(setShouldRedirect(new PayloadWrapper(shouldRedirect))),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AFrameControlApp);
